import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

export interface ScreenshotRequest {
  url: string;
}

export interface ScreenshotResponse {
  url: string;
  format: "jpeg" | "png" | "jpg";
  base64Image: string;
}

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const screenshotApi = createApi({
  reducerPath: "screenshotApi",

  // 🚫 NO AUTH
  baseQuery: createCustomBaseQuery(
    `${API_BASE_URL}/healthcheck/`,
    { skipAuth: true }
  ),

  endpoints: (builder) => ({generateScreenshot: builder.mutation<ScreenshotResponse,ScreenshotRequest>({
      query: ({ url }) => ({
        url: "screenshot",
        method: "POST",
        body: { url },
      }),
    }),
  }),
});


export const {
  useGenerateScreenshotMutation,
} = screenshotApi;
